<template>
  <div id="app" class="bigdata_page" >
    <router-view/>
    
  </div>
</template>
<script>

export default {
  name:'',
  components: {},
  props: {},
  data() {
      return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store") ) {
    //     this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    // } 

    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //     sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    // })
  },
  mounted() {
    // console.log(this.$route.path)
  }
}
</script>
<style>
@import '/css/base.css';
html,
body,
#app {
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
